import store from '../store'

function isUserProvider () {
  return store.state.userProvider
}

export default function plugin (Vue) {
  if (plugin.installed) {
    return
  }

  plugin.installed = true

  // eslint-disable-next-line no-param-reassign
  Vue.prototype.$userProvider = isUserProvider
}
